var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 4.89995H15.4V4.69995C15.4 3.89995 14.7 3.19995 13.9 3.19995H10C9.2 3.19995 8.5 3.89995 8.5 4.69995V4.89995H4.2C3 4.89995 2 5.89995 2 7.09995V17.8C2 19 3 20 4.2 20H19.8C21 20 22 19 22 17.8V7.09995C22 5.89995 21 4.89995 19.8 4.89995ZM10.1 4.69995H14V6.49995H10.1V4.69995ZM20.5 17.8C20.5 18.2 20.2 18.5 19.8 18.5H4.2C3.8 18.5 3.5 18.2 3.5 17.8V7.09995C3.5 6.69995 3.8 6.39995 4.2 6.39995H8.6V6.49995C8.6 7.29995 9.2 7.99995 10.1 7.99995H14C14.8 7.99995 15.5 7.29995 15.5 6.49995V6.39995H19.9C20.3 6.39995 20.6 6.69995 20.6 7.09995V17.8H20.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 10.7H5.80001C5.50001 10.7 5.20001 10.4 5.20001 10.1C5.20001 9.8 5.50001 9.5 5.80001 9.5H18.1C18.4 9.5 18.7 9.8 18.7 10.1C18.7 10.4 18.5 10.7 18.2 10.7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 13.9H5.80001C5.50001 13.9 5.20001 13.6 5.20001 13.3C5.20001 13 5.50001 12.7 5.80001 12.7H18.1C18.4 12.7 18.7 13 18.7 13.3C18.8 13.6 18.5 13.9 18.2 13.9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 16.8001H5.80001C5.50001 16.8001 5.20001 16.5001 5.20001 16.2001C5.20001 15.9001 5.50001 15.6001 5.80001 15.6001H18.1C18.4 15.6001 18.7 15.9001 18.7 16.2001C18.7 16.5001 18.5 16.8001 18.2 16.8001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.84ccfd2d6a98d9270ec246e7d3e8bb85.svg";
export { ForwardRef as ReactComponent };